import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../colorVars';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import CloseWindowButton from '../../../../atomic/buttons/closeWindow/CloseWindowButton';
import { Body2 } from '../../../../atomic/text/Text';
import style from './AddAlertComponent.module.css';
import { AddAlertForm } from './addAlertForm/AddAlertForm';

export const AddAlertComponent = observer(
  ({ moduleId, layoutType }) => {
    const { layoutStore } = useWebsocketStore();

    const removeModule = () => {
      layoutStore.removeModuleFromCurrentLayout(layoutType, moduleId);
    };

    return (
      <div className={style.container}>
        <header className={style.header}>
          <div className={style.group}>
            <Body2 margin="0 5px 0 0" color={colors.lightGrey} fontWeight={700}>
              Add Alert
            </Body2>
          </div>

          <CloseWindowButton
            width={15}
            stroke={2}
            color={colors.red}
            handleClick={removeModule}
          />
        </header>
        <div className={style.form}>
          <AddAlertForm />
        </div>
      </div>
    );
  }
);
